<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.INVOICE_REMINDERS' | translate }}</h1>
    <astral-popover [helpText]="'INVOICE.HEADER_TOOLTIP.INVOICE_REMINDER'"></astral-popover>
  </div>
  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinitions"
    [itemsSource]="itemsSource"
    [menuDefinition]="menuDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [isToolbarSticky]="true"
    [preferencesKey]="preferencesKey"
    (rowClick)="onRowClicked($event)"
  ></app-multiselect-list-view>
</section>
